<section class="change-password">
  <form
    class="container type--xs change-password__container"
    [formGroup]="changePasswordForm"
    *ngIf="!result || (result && !result.Succeeded)"
    (submit)="changePassword(changePasswordForm.value)"
  >
    <h1 class="change-password__title">Change your password</h1>
    <span class="change-password__subtitle"
      >Please enter your current and new password below.</span
    >
    <mat-form-field class="full--width">
      <input
        matInput
        type="password"
        placeholder="Current password"
        formControlName="currentPassword"
      />
    </mat-form-field>

    <mat-form-field class="full--width">
      <input
        matInput
        type="password"
        placeholder="New password"
        formControlName="password"
      />
    </mat-form-field>

    <mat-form-field class="full--width">
      <input
        matInput
        type="password"
        placeholder="Confirm password"
        formControlName="passwordVerify"
      />
    </mat-form-field>

    <p class="error-message type--inverse" *ngIf="result && !result.Succeeded">
      <span *ngIf="result.Errors">{{ result.Errors[0] }}</span>
      <span *ngIf="!result.Errors"
        >An unknown error occured, please try again or request a new
        password.</span
      >
    </p>
    <div class="change-password__toolbar">
      <button
        class="button change-password__toolbar__button"
        [disabled]="changePasswordForm.invalid || !passwordsEqual"
        [class.is--loading]="loading"
      >
        Save
      </button>
    </div>
  </form>

  <div
    class="container type--xs forgot-password__container"
    *ngIf="result && result.Succeeded"
  >
    <h1 class="forgot-password__title">All done!</h1>
    <span class="forgot-password__subtitle"
      >Your password has succesfully been changed. You can now log in using your
      new password.</span
    >
  </div>
</section>
